import { createContext, useContext, useState } from "react";
import { leaderboardAPI } from "../services/api";

export const LeaderboardContext = createContext();

export const LeaderboardProvider = ({ children }) => {
  // -------- Load Global Leaderboard --------
  const loadLeaderboard = async (params = {}) => {
    try {
      const response = await leaderboardAPI.loadLeaderboard();
      return response;
    } catch (error) {
      throw error;
    }
  };

  //-------- Load Games Leaderboard ----------
  const loadGameLeaderboard = async () => {
    try {
      const response = await leaderboardAPI.loadGameLeaderboard();
      return response;
    } catch (error) {
      throw error;
    }
  };

  //-------- Load Game Profile Leaderboard ----------
  const leaderboardProfile = async () => {
    try {
      const response = await leaderboardAPI.leaderboardProfile();
      return response;
    } catch (error) {
      throw error;
    }
  };

  //-------- Load  Game Leaderboard ----------
  const gameLeaderboard = async (gameId) => {
    try {
      const response = await leaderboardAPI.gameLeaderboard(gameId);
      return response;
    } catch (error) {
      throw error;
    }
  };

  return (
    <LeaderboardContext.Provider
      value={{
        //-------- Actions ---------
        loadLeaderboard,
        loadGameLeaderboard,
        leaderboardProfile,
        gameLeaderboard,
      }}
    >
      {children}
    </LeaderboardContext.Provider>
  );
};

// Custom hook to use the tournament context
export const useLeaderboard = () => {
  const context = useContext(LeaderboardContext);
  if (context === undefined) {
    throw new Error("useTournament must be used within a Leaderboard Provider");
  }
  return context;
};
